import { render, staticRenderFns } from "./ReplacementItemModal.vue?vue&type=template&id=96f04098"
import script from "./ReplacementItemModal.vue?vue&type=script&lang=js"
export * from "./ReplacementItemModal.vue?vue&type=script&lang=js"
import style0 from "./ReplacementItemModal.vue?vue&type=style&index=0&id=96f04098&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports